import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useAttributeState } from './ZigbeeAttributesSlice';
export const ZigbeeAttributeEditBool = forwardRef((props, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => ({
        getValue: () => {
            var _a, _b;
            const value = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false;
            return { type: 'Bool', value };
        }
    }), []);
    return (_jsx("input", { ref: inputRef, type: "checkbox", style: { width: 'unset' }, defaultChecked: props.value }));
});
ZigbeeAttributeEditBool.displayName = 'ZigbeeAttributeEditBool';
export const ZigbeeAttributeEditInt = forwardRef((props, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => ({
        getValue: () => {
            var _a, _b;
            const value = parseInt((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '');
            if (isNaN(value))
                return { type: props.type, undefined };
            else
                return { type: props.type, value };
        }
    }), []);
    return (_jsx("input", { ref: inputRef, type: "text", name: 'props.name', style: { width: 'unset' }, size: 8, defaultValue: props.value }));
});
ZigbeeAttributeEditInt.displayName = 'ZigbeeAttributeEditInt';
export const ZigbeeAttributeEdit = forwardRef((props, ref) => {
    const attr = useAttributeState(props.nid, props.eid, props.cid, props.aid);
    if (attr != undefined) {
        const type = attr === null || attr === void 0 ? void 0 : attr.typedValue.type;
        switch (type) {
            case 'Bool': {
                const value = attr.typedValue.value;
                return (_jsx(ZigbeeAttributeEditBool, { ref: ref, type: type, value: value }));
            }
            case 'Int8':
            case 'Int16':
            case 'Int32':
            case 'UInt8':
            case 'UInt16':
            case 'UInt32':
            case 'Enum8':
            case 'Enum16':
            case 'Bitmap8':
            case 'Bitmap16':
            case 'Bitmap32': {
                const value = attr.typedValue.value;
                return (_jsx(ZigbeeAttributeEditInt, { ref: ref, type: attr.typedValue.type, value: value }));
            }
            default:
                console.log('Unknown type ', attr === null || attr === void 0 ? void 0 : attr.typedValue.type);
                break;
        }
    }
});
ZigbeeAttributeEdit.displayName = 'ZigbeeAttributeEdit';
